// extracted by mini-css-extract-plugin
export var avatarContainer = "_e6-0";
export var avatarTypingWave = "_e6-i";
export var gray = "_e6-f";
export var green = "_e6-c";
export var icon = "_e6-9";
export var image = "_e6-1";
export var lg = "_e6-6";
export var md = "_e6-5";
export var presenceDot = "_e6-b";
export var red = "_e6-d";
export var sm = "_e6-4";
export var status = "_e6-a";
export var typingDot = "_e6-h";
export var typingPill = "_e6-g";
export var xl = "_e6-7";
export var xs = "_e6-3";
export var xxl = "_e6-8";
export var xxs = "_e6-2";
export var yellow = "_e6-e";